import {OnInit, Input, AfterViewInit, OnChanges, SimpleChanges} from '@angular/core';
import { Directive, ElementRef, Renderer } from '@angular/core';
import {NgControl, NgModel} from "@angular/forms";
import * as moment from "moment";

declare var jQuery: any;
declare var Switchery: any;

@Directive({
  selector: '[appInputSwitch]'
})
export class InputSwitchDirective implements OnInit, AfterViewInit, OnChanges {

  @Input() inputData: boolean;
  public switcher;
  constructor(public el: ElementRef, private ngModel: NgModel, private control: NgControl) { }

  ngOnInit() {
    this.initSwitcher();
  }

  ngAfterViewInit() {

  }

  initSwitcher() {
    setTimeout(() => {
      if (this.switcher) {
        this.switcher.switcher.remove();
      }
      const switchery = new Switchery(this.el.nativeElement, {
        size: 'small'
      });
      this.switcher = switchery;
      let switchEl = this.switcher.element;
      switchEl.checked = this.ngModel.model;
      switchEl.addEventListener('change', s => {
        this.control.control.setValue(switchEl.checked);
      });
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.initSwitcher();
  }
}
